import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { formatProfile } from "../../../../utils/utils";

const styles = () => ({
  root: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
});

const Position = ({ classes, item, disabled }) => {
  return (
    <Typography
      variant="body1"
      className={classes.root}
      style={{
        color: disabled ? "#B1B3B9" : "#71737B",
        marginTop: "5px",
      }}
    >
      {formatProfile(item)}
    </Typography>
  );
};

Position.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(Position);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/Position.jsx